document.addEventListener('DOMContentLoaded', function(){
	let iw = 105;
	let ih = 108;
	let flies = [
		'Тихими взмахами крыльев бабочка улетает в ночь.',
		'Вы ловите бабочку, но вдруг она начинает светиться и, расходясь пучками света, растворяется в ваших руках.',
		'Легко взмахнув крыльями, бабочка растворилась в темноте.',
		'Вы дотронулись до бабочки, и приятное тепло разлилось по вашей руке от точки касания, но через мгновение оно исчезло. Как и бабочка.',
		'При приближении вашей руки бабочка засияла синим светом, которое обволокло ваше тело. Удача повысилась на 1.',
		'"Мне очень приятно", сказала бабочка, и пока вы приходили в себя от этой мысли, она растворилась в ночи.',
	];

	let rand = (from, to) => {
		return Math.floor(Math.random() * (to - from) + from);
	};

	let mx = window.innerWidth - iw;
	let my = window.innerHeight - ih;

	let $el = document.createElement('img');
	$el.src = '/assets/i/butterfly.gif';

	$el.addEventListener('click', function(e){
		alert(flies[rand(0, flies.length)]);
		$el.style.display = 'none';
	});

	$el.style.position = 'fixed';
	$el.style.display = 'none';

	document.querySelector('body').appendChild($el);

	setInterval(() => {
		let h = new Date(Date.now()).getHours();
		if ((h < 4 || h > 21) && Math.random() < 0.004){
			$el.style.left = rand(0, mx) + 'px';
			$el.style.top = rand(0, my) + 'px';

			$el.style.display = 'block';
		}
	}, 60000);
});
